<template>
  <div class="detail-product-card flex-column gap-label" v-if="data">
    <!-- Deskripsi Produk -->
    <div class="flex-column gap-label">
      <span class="text-label">Deskripsi Produk</span>
      <span class="text-value">{{ data.description || '-' }}</span>
    </div>

    <div class="gray-divider" v-if="shouldShowInfoLainnya"></div>

    <!-- Persyaratan -->
    <div class="flex-column gap-label" v-if="shouldShowInfoLainnya">
      <span class="text-label">Persyaratan</span>
      <div class="flex-column gap-label-value">
        <span class="text-value">Syarat Kepemilikan Rekening</span>
        <span class="text-value-blue">
          <i>{{ data.syarat_kepemilikan_rekening == true ? 'Ya' : 'Tidak' }}</i>
        </span>
      </div>
    </div>

    <div class="gray-divider"></div>

    <!-- Biaya-Biaya -->
    <div class="flex-column gap-label">
      <span class="text-label">Biaya-Biaya</span>
      <div class="flex-column gap-label-value">
        <span class="text-value">Biaya Administrasi</span>
        <span class="text-value-blue">
          <i>{{ data.biaya_administrasi ? $formatRupiah(data.biaya_administrasi) : 'Tidak Ada' }}</i>
        </span>

        <span class="text-value">Biaya Dibawah Saldo Minimum</span>
        <span class="text-value-blue">
          <i>{{ data.biaya_dibawah_saldo_minimum ? $formatRupiah(data.biaya_dibawah_saldo_minimum) : 'Tidak Ada' }}</i>
        </span>

        <span class="text-value">Biaya Penutupan Rekening</span>
        <span class="text-value-blue">
          <i>{{ data.biaya_penutupan_rekening ? $formatRupiah(data.biaya_penutupan_rekening) : 'Tidak Ada' }}</i>
        </span>

        <span class="text-value">Biaya Penarikan Sebelum Jatuh Tempo</span>
        <span class="text-value-blue">
          <i>{{ data.biaya_penarikan_sebelum_jatuh_tempo ? $formatRupiah(data.biaya_penarikan_sebelum_jatuh_tempo) : 'Tidak Ada' }}</i>
        </span>

        <span class="text-value">Biaya Lainnya</span>
        <span class="text-value-blue">
          <i>{{ data.keterangan ? `${data.keterangan} : ${$formatRupiah(data.biaya_lain_lain)}` : 'Tidak Ada' }}</i>
        </span>
      </div>
    </div>

    <div class="gray-divider" v-if="shouldShowInfoLainnya"></div>

    <!-- Informasi Lainnya -->
    <div class="flex-column gap-label" v-if="shouldShowInfoLainnya">
      <span class="text-label">Informasi Lainnya</span>
      <div class="flex-column gap-label-value">
        <span class="text-value">Automatic Roll Over</span>
        <span class="text-value-blue">
          <i>{{ data.automatic_roll_over == true ? 'Ya' : 'Tidak' }}</i>
        </span>

        <span class="text-value">Penarikan Bagi Hasil</span>
        <span class="text-value-blue">
          <i>{{ data.penarikan_bagi_hasil === 'tiap-bulan' ? 'Setiap Bulan' : 'Akhir Periode' }}</i>
        </span>
      </div>
    </div>

    <div class="gray-divider"></div>

    <!-- Ulasan -->
    <div class="flex-column gap-label">
      <span class="text-label">Ulasan</span>
      <div class="flex-column gap-label-value">
        <span class="text-value">Syarat Pengajuan:</span>
        <ul class="list-style">
          <li class="text-value">Calon Nasabah merupakan Warga Negara Indonesia</li>
          <li class="text-value">Usia minimal 17 tahun dan maksimal 60 tahun</li>
        </ul>

        <span class="text-value mt-3">Dokumen yang harus disiapkan:</span>
        <ul class="list-style">
          <li class="text-value">Kartu Identitas Asli (KTP/SIM/Paspor)</li>
          <li class="text-value">NPWP, Akte Pendirian Perusahaan dan Perubahan Terakhir NIB (untuk nasabah Badan Hukum)</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Skeleton Loader -->
  <div v-else class="detail-product-card flex-column gap-label skeleton">
    <div class="skeleton-box" style="height: 20px; width: 60%;"></div>
    <div class="skeleton-box" style="height: 18px; width: 100%;"></div>
    <div class="skeleton-box" style="height: 18px; width: 90%;"></div>
    <div class="skeleton-box" style="height: 18px; width: 95%;"></div>
    <div class="skeleton-box" style="height: 18px; width: 80%;"></div>
  </div>
</template>

<script>
export default {
  name: "CardDeskripsiUlasan",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    shouldShowInfoLainnya() {
      const akadName = (this.data && this.data.akad && this.data.akad.name) || "";
      const excludedAkads = ["Al-Wadi'ah", "Al-Murabahah"];
      return !excludedAkads.includes(akadName);
    }
  },
};
</script>

<style scoped>
.detail-product-card {
  padding: 25px 30px;
  border: 1px solid #6c6d70;
  border-radius: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.gap-label {
  gap: 20px;
}

.gap-label-value {
  gap: 10px;
}

.text-label {
  font-size: 20px;
  text-transform: uppercase;
  color: #13346c;
  font-weight: 500;
}

.text-value {
  font-size: 18px;
  color: #6c6d70;
  font-weight: 400;
}

.text-value-blue {
  font-size: 18px;
  color: #13346c;
  font-weight: 500;
}

.gray-divider {
  border-bottom: 1px solid #6c6d70;
  width: 100%;
}

.list-style {
  list-style-type: disc;
  list-style-position: inside;
  padding-left: 0;
}

.skeleton-box {
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

@media (max-width: 768px) {
  .text-label {
    font-size: 12px !important;
  }

  .text-value,
  .text-value-blue {
    font-size: 16px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/public/component-detail-deposito-tabungan/CardDeskripsi.vue